import { ACTION_DASHBOARD_VIEW } from "../actions/dashboard";

let initialReducer = {
    regions: [],
    dateCheck: ''
}

let DashboardReducers = (state = initialReducer, action) => {
    switch (action.type) {
        case ACTION_DASHBOARD_VIEW.type:
            return {
                ...state,
                regions: action.payload.regions,
                dateCheck: action.payload.dateCheck,
            };
        default:
            return state;
    }
}

export default DashboardReducers